module.exports = __webpack_public_path__ + "img/welcome-image.93e74664.webp";